/* unplugin-vue-components disabled */import script from "./PontHistoryPoupup.vue?vue&type=script&setup=true&lang=js"
export * from "./PontHistoryPoupup.vue?vue&type=script&setup=true&lang=js"

import "./PontHistoryPoupup.vue?vue&type=style&index=0&id=0b8c4ac2&lang=scss"

const __exports__ = script;

export default __exports__